<script lang="ts">
    import CN from "classnames";

    type IconSize = "small" | "medium" | "large" | "fullWidth";

    //Optional Props
    export let className: string;
    export { className as class };
    export let size: IconSize = "medium";
    export let isDirectionRtl: boolean | null = null;
    export let isBrandingIconColor = true;
    export let viewBox: string | null = null;

    //Logic
    const calculateIconSize = (iconSize: IconSize) => {
        if (iconSize === "small") return { width: "16px", height: "16px" };
        if (iconSize === "large") return { width: "32px", height: "32px" };
        if (iconSize === "fullWidth") return { width: "100%", height: "100%" };

        return { width: "24px", height: "24px" };
    };
    const { width, height } = calculateIconSize(size);

    //Reactive Statement
    $: classes = CN("gw-rd-icon", className, {
        "gw-rd-icon-branding-color": isBrandingIconColor,
        "gw-rd-icon--transform": isDirectionRtl,
    });
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    {viewBox}
    class={classes}
    role="img"
    fill="none"
    aria-hidden="true"
    {...$$restProps}
    style={`
        --width: ${width};
        --height: ${height};
    `}
>
    <g>
        <slot />
    </g>
</svg>

<style lang="postcss">
    .gw-rd-icon {
        width: var(--width);
        height: var(--height);

        &-branding-color {
            color: var(--gw-rd-content__icons-theme-color);
        }

        &--transform {
            transform: rotateY(180deg);
        }
    }
</style>
